import { useEffect, useRef } from 'react';
import { type PageContext } from '../model/chatTypes';

export function useAutoOpen(onAutoOpen: () => void, context: PageContext): void {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const firedRef = useRef(false);

  useEffect(() => {
    // После авторизации (cabinet) — только 1 раз за сессию
    if (context === 'cabinet') {
      if (sessionStorage.getItem('chatAutoOpened') === 'true') return;
    }
    // До авторизации (public, login, register) — каждый раз при загрузке

    if (firedRef.current) return;

    const startTimer = () => {
      if (firedRef.current) return;
      timerRef.current = setTimeout(() => {
        if (!firedRef.current) {
          firedRef.current = true;
          if (context === 'cabinet') {
            sessionStorage.setItem('chatAutoOpened', 'true');
          }
          onAutoOpen();
        }
      }, 3000);
    };

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      startTimer();
    };

    startTimer();

    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, resetTimer, { passive: true }));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
  }, [onAutoOpen, context]);
}
